// extracted by mini-css-extract-plugin
module.exports = {"HeaderTitle":"fundwithdrawal_HeaderTitle__342JY","Details":"fundwithdrawal_Details__2unI2","DetailItem":"fundwithdrawal_DetailItem__Rg4aG"};